import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setUsernameRenameWidgetUsername = createAction(
  `${reduxKey}.SET_USERNAME_RENAME_WIDGET_USERNAME`,
  (username: string) => ({ username })
);

export const setUsernameRenameWidgetPassword = createAction(
  `${reduxKey}.SET_USERNAME_RENAME_WIDGET_PASSWORD`,
  (password: string) => ({ password })
);

export const saveUsernameRename = createAction(
  `${reduxKey}.SAVE_USERNAME_RENAME`,
  () => ({})
);

export const saveUsernameRenameSuccess = createAction(
  `${reduxKey}.SAVE_USERNAME_RENAME_SUCCESS`,
  () => ({})
);

export const saveUsernameRenameFailure = createAction(
  `${reduxKey}.SAVE_USERNAME_RENAME_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
